import React, { useEffect, useState } from 'react'
import PosRequestConfirmTerm from './pos-request-confirm-term'
import PosRequestConfirmButton from './pos-request-confirm-button'

function PosRequestConfirm({ objectDto, setLoading, setObjectDto, listFile, setValidate }) {
    const [term, setTerm] = useState(objectDto.termChecked === 1 ? true : false);
    const onTermChange = (e) => {
        setTerm(e.target.checked);
        setObjectDto({ ...objectDto, termChecked: e.target.checked === true ? 1 : 0 })
    }
    useEffect(() => {
        if (objectDto.termChecked !== undefined)
            setTerm(objectDto.termChecked === 1 ? true : false);
    }, [objectDto]);
    return (
        <React.Fragment>
            {/* Term */}
            <PosRequestConfirmTerm objectDto={objectDto} term={term} onTermChange={onTermChange} />
            {/* Button and Request Success UI */}
            <PosRequestConfirmButton objectDto={objectDto} term={term} setLoading={setLoading} setObjectDto={setObjectDto} listFile={listFile} setValidate={setValidate} />
        </React.Fragment>
    )
}

export default PosRequestConfirm